<template>
  <div>
    <el-card shadow="always">
      <div class="side-frame">
        <span style="font-size: 14px; color: #606266">基本信息</span>
      </div>
      <edit-form
        ref="editForm"
        :disabled="isDisableEditForm"
        :params="params"
        @codeChange="onCodeChange"
      />
      <div class="d-flex justify-content-end mb-2">
        <el-button
          v-if="!isDisableEditForm"
          type="primary"
          size="small"
          @click="$refs.editForm.save()"
          >保存</el-button
        >
      </div>
      <el-divider></el-divider>
      <div v-if="code" class="mt-2 mb-4">
        <div class="side-frame">
          <span style="font-size: 14px; color: #606266">中转线路</span>
          <el-divider direction="vertical"></el-divider>
          <el-button
            class="ml-2"
            style="font-size: 14px;"
            v-if="!isDisableEditForm"
            type="text"
            @click="
              openDetailEditFrom({
                type: 'add',
              })
            "
            >新增线路</el-button
          >
        </div>
        <transfer-timeline
          ref="transferTimeline"
          :isDisableEditForm="!isDisableEditForm"
          :code="params.transferRuleCode"
          @openDetailEditFrom="openDetailEditFrom"
        />
      </div>
    </el-card>
    <!-- region 中转策略子表详情 form dialog -->
    <el-dialog
      v-if="detailEditFormDialogOptions.visible"
      v-el-dialog-drag
      show-close
      append-to-body
      visible
      width="900px"
      :title="detailEditFormDialogOptions.title"
      :close-on-click-modal="false"
      :before-close="() => $refs.detailEditForm.cancel()"
    >
      <detail-edit-form
        ref="detailEditForm"
        :disabled="detailEditFormDialogOptions.disabled"
        :transferRuleDetailCode="detailEditFormDialogOptions.code"
        :transferRuleCode="code"
        @reload="$refs.transferTimeline.reload(code)"
        @close="closeDetailEditForm"
      />
      <span slot="footer">
        <el-button size="small" @click="$refs.detailEditForm.cancel()"
          >取消</el-button
        >
        <el-button
          type="primary"
          size="small"
          v-if="!detailEditFormDialogOptions.disabled"
          @click="$refs.detailEditForm.save()"
          >保存</el-button
        >
      </span>
    </el-dialog>
    <!-- endRegion -->
  </div>
</template>
<script>
import DetailEditForm from '../components/detail-edit-form'
import TransferTimeline from '../components/transfer-timeline/index'
import EditForm from '../components/edit-form'
export default {
  name: 'master-transferRule-detail',
  components: {
    TransferTimeline,
    DetailEditForm,
    EditForm,
  },
  data() {
    return {
      detailEditFormDialogOptions: {
        visible: false,
        transferRuleDetailCode: '',
      },
      code: '',
    }
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    // 是否禁用表单
    isDisableEditForm() {
      return this.pageType === 'detail'
    },
  },
  mounted() {
    this.code = this.params.transferRuleCode
  },
  methods: {
    onCodeChange(val) {
      this.code = val
    },
    // region 子单详情弹窗表格
    openDetailEditFrom({ type, code = '' }) {
      const types = {
        edit: '编辑子单策略信息',
        add: '添加子单策略信息',
      }
      this.detailEditFormDialogOptions = {
        visible: true,
        title: types[type],
        code,
      }
    },
    closeDetailEditForm() {
      this.detailEditFormDialogOptions.visible = false
    },
    // endregions
  },
}
</script>
<style lang="scss" scoped>
.side-frame {
  padding: 1px 10px;
  border-left: 3px solid $color-primary;
  margin: 15px 0;
}
</style>
